<div class="o-grid o-grid--center-h">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p" [ngClass]="{'o-grid__cell--w-50@md-and-up o-grid__cell--w-40@lg-and-up': !vm.isFluid}">
		<img alt="No content" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/bg-empty.svg" class="c-card__img">
		<p id="noContentTextLabel" class="c-text">{{ 'Services.Title.NoContent' | translate }}</p>
	</div>
</div>
